export const GET_DOCUMENTATION = "GET_DOCUMENTATION";
export const UPLOAD_DOCUMENTATION = "UPLOAD_DOCUMENTATION";
export const GET_USER_MANUAL = "GET_USER_MANUAL";
